import { render, staticRenderFns } from "./feedtrans.vue?vue&type=template&id=26d92274&scoped=true&"
import script from "./feedtrans.vue?vue&type=script&lang=js&"
export * from "./feedtrans.vue?vue&type=script&lang=js&"
import style0 from "./feedtrans.vue?vue&type=style&index=0&id=26d92274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d92274",
  null
  
)

export default component.exports